// API Configuration
// This file centralizes all API endpoint configuration

const getApiBaseUrl = () => {
  // Check if we're in development mode
  const isDevelopment = import.meta.env.DEV;
  
  // Check if we're on Vercel or production
  const isVercel = typeof window !== 'undefined' && window.location.hostname.includes('vercel.app');
  
  // Priority order for API URL resolution:
  // 1. VITE_API_URL (legacy support)
  // 2. VITE_BACKEND_URL_PROD (production)
  // 3. VITE_BACKEND_URL_DEV (development)
  // 4. Default fallbacks
  
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }
  
  if (isVercel || (!isDevelopment && import.meta.env.PROD)) {
    // Production environment
    return import.meta.env.VITE_BACKEND_URL_PROD || 'https://alex-game-backend.onrender.com';
  } else {
    // Development environment
    return import.meta.env.VITE_BACKEND_URL_DEV || 'http://localhost:3000';
  }
};

const getSocketUrl = () => {
  const isDevelopment = import.meta.env.DEV;
  const isVercel = typeof window !== 'undefined' && window.location.hostname.includes('vercel.app');
  
  // IMPORTANT: Vite proxy ONLY works in development mode (npm run dev)
  // In production (npm run build), Vite creates static files and there's no dev server/proxy
  // So we need different strategies for dev vs production:
  
  // DEVELOPMENT MODE: Use Vite proxy for optimized WebSocket performance
  // - Vite dev server runs on localhost:5173
  // - Proxy forwards /socket.io to backend (configured in vite.config.js)
  // - This gives us low latency and smooth connections
  if (isDevelopment && !isVercel && typeof window !== 'undefined') {
    return window.location.origin; // Uses Vite proxy → backend
  }
  
  // PRODUCTION MODE: Connect directly to backend URL
  // - No Vite dev server running (static files only)
  // - Must connect directly to backend server
  // - Uses VITE_BACKEND_URL_PROD environment variable
  return getApiBaseUrl(); // Direct connection to production backend
};

// Export the configuration
export const API_CONFIG = {
  BASE_URL: getApiBaseUrl(),
  SOCKET_URL: getSocketUrl(),
  
  // Auth endpoints
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    VERIFY_EMAIL: '/auth/verify-email',
    RESEND_VERIFICATION: '/auth/resend-verification',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    PROFILE: '/auth/profile',
    HEALTH: '/auth/health'
  },
  
  // Game endpoints
  GAME: {
    HEALTH: '/health',
    CREATE_PAYMENT: '/api/create-user-payment',
    TEST_CLAIM: '/api/rewards/test-claim'
  }
};

// Helper function to get full API URL
export const getApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Log the configuration for debugging
// console.log('🌐 API Configuration:', {
//   BASE_URL: API_CONFIG.BASE_URL,
//   SOCKET_URL: API_CONFIG.SOCKET_URL,
//   ENV: import.meta.env.MODE,
//   DEV: import.meta.env.DEV,
//   PROD: import.meta.env.PROD
// });

export default API_CONFIG;
